// import axios from "./APIUtils";
import axios from "./axios.provider";
import { apiConfig } from "./config";
import { parseList } from "./utility";

const GetUserByUserName = async function(userName) {
  try {
    const response = await axios.get(
      `${apiConfig}/api/Master/GetMasterUserByUserName/${userName}`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const _userservice = {
  GetUserByUserName,
};
